var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: ["price", { price_sign: _vm.hasSign }] },
    [
      _vm.hasValidValue
        ? [_vm._v("\n    " + _vm._s(_vm._f("price")(_vm.value)) + "\n  ")]
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }